import * as Actions from '../../actions/integration/type';

const initialState = {
  // test torque payment creds

  twilioGetCredsLoading: false,
  twilioGetCredsSuccess: false,
  twilioGetCredsError: false,
  twilioData: '',
  // add torque payment creds

  isLoading: false,
  addTwilioCredsSuccess: '',
  addTwilioCredsError: '',

  // torque payment
  twilioLoading: false,
  twilio: '',
  twilioError: '',
};

export const twilioReducer = (state = initialState, action) => {
  switch (action.type) {
    // Test Torque payment Credentials
    case Actions.GET_TWILIO_CREDS_REQUEST:
      return {
        ...state,
        twilioGetCredsLoading: true,
      };
    case Actions.GET_TWILIO_CREDS_SUCCESS:
      return {
        ...state,
        twilioGetCredsLoading: false,
        twilioGetCredsSuccess: true,
        twilioData: action?.payload?.data || '',
      };
    case Actions.GET_TWILIO_CREDS_FAIL:
      return {
        ...state,
        twilioGetCredsLoading: false,
        twilioGetCredsError: true,
      };
    // Add Torque twilio Credentials
    case Actions.ADD_TWILIO_CREDS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.ADD_TWILIO_CREDS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        addTwilioCredsSuccess: true,
      };
    case Actions.ADD_TWILIO_CREDS_FAIL:
      return {
        ...state,
        isLoading: false,
        addTwilioCredsError: action.payload,
      };

    // Delete twilio Credentials
    case Actions.DELETE_TWILIO_CREDS_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
    case Actions.DELETE_TWILIO_CREDS_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteCredsSuccess: true,
      };
    case Actions.DELETE_TWILIO_CREDS_FAIL:
      return {
        ...state,
        deleteLoading: false,
        addTwilioCredsError: action.payload,
      };

    case Actions.UPDATE_TWILIO_STATE:
      return {
        ...state,
        isLoading: false,
        twilioData: action?.payload || '',
      };
    case Actions.CLEAR_UPDATED_DATA_TWILIO:
      return {
        ...state,
        isLoading: false,
        deleteLoading: false,
        deleteCredsSuccess: false,
        addTwilioCredsSuccess: false,
      };

    default:
      return state;
  }
};
